export let headerBrandName = "F5gumd";
export default {headerBrandName};